import { render, staticRenderFns } from "./api_alerts.vue?vue&type=template&id=b0b0dd90&"
import script from "./api_alerts.vue?vue&type=script&lang=js&"
export * from "./api_alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports